<template>
	<Dropdown
		:value="value"
		:searchable="true"
		:is-small="isSmall"
		:placeholder="placeholder"
		:options="options"
		:no-search-results-message="noSearchResultsMessageComp"
		:disabled="disabled"
		@input="onChange"
	>
		<template #item-list="{ option }">
			<div class="dropdown-item">
				<div
					class="leading"
					:style="{
						backgroundImage: `url(${option.imageUrl})`,
					}"
				/>
				<div class="content">
					<div class="title">
						<span>{{ option.label }}</span>
					</div>
					<div class="description">
						{{ option.date }}, {{ option.duration }}
					</div>
				</div>
			</div>
		</template>
	</Dropdown>
</template>

<script>
import Dropdown from '@components/dropdown/Dropdown';
import moment from 'moment';
import { formatTimestampAsMinutesSeconds } from '@shared/utils/timeUtils';

export default {
	name:       'VideosDropdown',
	components: { Dropdown },
	props:      {
		value: {
			type:    Object,
			default: () => {},
		},
		videos: {
			type:     Array,
			required: true,
		},
		placeholder: {
			type: String,
		},
		isSmall: {
			type: Boolean,
		},
		searchable: {
			type: Boolean,
		},
		noSearchResultsMessage: {
			type: String,
		},
		disabled: {
			type: Boolean,
		},
	},
	computed: {
		options() {
			return this.videos.map((video) => ({
				value:    video,
				label:    video.name,
				date:     this.formatDate(video.start),
				duration: formatTimestampAsMinutesSeconds(video.duration),
				imageUrl: video.imageUrl ? video.imageUrl : '/images/background-player.jpg',
			}));
		},
		noSearchResultsMessageComp() {
			return this.noSearchResultsMessage || this.transUcfirst('analysis.no_videos_found');
		},
	},
	methods: {
		onChange(value) {
			this.$emit('input', value);
		},
		formatDate(date) {
			return moment(date).format('DD.MM.YYYY');
		},
	},
};
</script>

<style lang="scss" scoped>
@import '@shared/sass/shared-variables';
@import '@videotools/sass/_fonts';

.dropdown-item {
	display: flex;
	align-items: center;
	padding-top: 8px;
	padding-bottom: 8px;
	width: 100%;

	.leading {
		width: 100px;
		height: 56px;
		background-size: cover;
		background-position: center;
		margin-right: 8px;
		flex: 0 0 100px;
	}

	.content {
		display: flex;
		flex-direction: column;
		flex: 0 1 100%;

		.title {
			@include text-md-1;
			color: var(--color-soft-white);
			margin-bottom: 4px;
			text-overflow: ellipsis;

			span {
				// white-space: nowrap;
			}
		}

		.description {
			@include text-sm-2;
			color: var(--color-grey-500);
		}
	}
}

::v-deep {
	li.is-small {
		min-height: initial;
		height: initial;
	}
}
</style>
